import LoginPop from './components/assembly/LoginPop.vue';
import router from './router/index.js';
import i18n from './i18n/i18n.js';

const loginPop = {};
loginPop.install = vue => {
	const ToastCon = vue.extend(LoginPop);
	const ins = new ToastCon();
	ins.$mount(document.createElement('div'));
	document.body.appendChild(ins.$el);
	vue.prototype.$showNotFoundLoginComponent = () => {
		ins.visible = true;
	}
	vue.prototype.$closeLogin = () => {
		ins.visible = false;
	}
	vue.prototype.$register = () => {
		ins.visible = false;
		router.push("/register");
	}
	vue.prototype.$modifyPsd = () => {
		ins.visible = false;
		router.push("/modifyPsd");
	}  
	
	vue.prototype.$t = (key) => i18n.t(key) ;
};
export default loginPop ;



// WEBPACK FOOTER //
// ./src/loginPop.js